module.exports = __webpack_public_path__ + "img/missions.b338b6cd.jpg";